import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Drawer as MuiDrawer, IconButton, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { colors } from "global/globalStyle";

import BaseLabel from "components/BaseLabel";
import Button from "components/Button";

import {
  Body,
  ContainerFooter,
  ContainerTwoComponents,
  DivFooter,
  DrawerForm,
} from "./styles";
import { DrawerProps } from "./types";

export const Drawer: React.FC<DrawerProps> = ({
  id,
  anchor = "right",
  width = 480,
  open,
  onClose,
  title,
  children,
  footer = "apply",
  onApply,
  onSearch,
  onClear,
  applyLabel,
  disabled,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingBottom,
  bodyHeight,
}) => {
  const { t } = useTranslation();
  const resolvedApplyLabel = applyLabel || t("common.apply");

  return (
    <MuiDrawer
      id={id}
      data-testid={id}
      anchor={anchor}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        },
      }}
    >
      {open && (
        <DrawerForm
          onSubmit={(event) => {
            event.preventDefault();
            if (footer === "apply" && !disabled && onApply) {
              onApply();
            }
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1.5}
            sx={{
              padding: "0 25px",
              height: "95px",
              backgroundColor: colors.background_primary,
            }}
          >
            <BaseLabel
              color={colors.default_base_white}
              fontWeight="700"
              fontSize="18px"
            >
              {title}
            </BaseLabel>
            <Stack direction="row" alignItems="center">
              <IconButton sx={{ p: 0 }} onClick={onClose}>
                <CloseIcon style={{ color: colors.default_hover_grey }} />
              </IconButton>
            </Stack>
          </Stack>

          <Body
            paddingBottom={paddingBottom}
            paddingLeft={paddingLeft}
            paddingRight={paddingRight}
            paddingTop={paddingTop}
            height={bodyHeight}
          >
            {children}
          </Body>

          <ContainerFooter>
            {footer === "apply" && (
              <DivFooter>
                <div>
                  <Button
                    id="button_aplicar"
                    data-cy="button_aplicar"
                    borderHoverColor={colors.neutral_white}
                    fontWeight="500"
                    disabled={disabled}
                    type="submit"
                  >
                    {resolvedApplyLabel}
                  </Button>
                </div>
              </DivFooter>
            )}
            {footer === "filter" && (
              <DivFooter>
                <ContainerTwoComponents>
                  <Button
                    id="button_aplicar"
                    borderHoverColor={colors.neutral_white}
                    fontWeight="500"
                    onClick={onClear}
                  >
                    {t("common.clear")}
                  </Button>
                  <Button
                    id="button_aplicar"
                    borderHoverColor={colors.neutral_white}
                    fontWeight="500"
                    onClick={onSearch}
                  >
                    {t("common.search")}
                  </Button>
                </ContainerTwoComponents>
              </DivFooter>
            )}
          </ContainerFooter>
        </DrawerForm>
      )}
    </MuiDrawer>
  );
};

export default Drawer;
